import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  Grid,
  TextField,
  Autocomplete
} from "@mui/material";
import { getOrders, ordersHandleFiltersInputs, restoreOrderFilters } from "redux/actions/orders/ordersActions";
import RegularButton from "components/CustomButtons/Button";
import { AutocompleteComponent } from "components/Autocomplete/AutocompleteComponent";
import { agentList, filterList, ORDER_FILTER_OPTIONS, ORDERS_SEARCH_PARAMS } from "../../helpers/agentList";
import { useSearch } from "hooks/useSearch";
import { newDate } from "../../helpers/dateTools";
import { dateValidator } from "../../helpers/dateValidator";
import { persistLocalStorage, getPersistLocalStorage } from "../../helpers/localstorageTool";


const style = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
};

export const RequestForm = () => {
  const location = useLocation();
  const hist = useHistory();
  const { stationsList, companiesList } = useSelector(({ companies }) => companies);
  const { stations, startDate, endDate, filter, company } = useSelector(({ orders }) => orders);
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();

  const dateRange = {
    min: newDate({ diffDays: -2 }),
    max: newDate({ diffDays: 7 }),
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();

    if (dateValidator(
      startDate, endDate, null, setSnackbar, { range: dateRange, allowFutureDates: true }
    )) return;

    if (stations.length === 0) {
      setSnackbar("Por favor, selecciona al menos una estación");
      return;
    }
    const stationsIDs = stations.map((s) => s.id);
    const ordersSearchParams = {
      startDate,
      endDate,
      filter,
      company,
      stations: stationsIDs,
      stationObjects: stations,
      isAgent: filter?.value === ORDER_FILTER_OPTIONS.IS_AGENT,
    };
    persistLocalStorage(ORDERS_SEARCH_PARAMS, ordersSearchParams);
    dispatch(getOrders(ordersSearchParams));
  };

  const handleDateChange = (field) => ({ target }) => {
    dispatch(ordersHandleFiltersInputs(field, newDate({ date: target.value })));
  };

  const handleChange = (v) => {
    const values = v.map((v) => v);
    dispatch(ordersHandleFiltersInputs("stations", values));
  };

  const handleFilter = (v) => {
    dispatch(ordersHandleFiltersInputs("filter", v.filter));
    dispatch(ordersHandleFiltersInputs("stations", []));
    dispatch(ordersHandleFiltersInputs("company", ""))
  }

  const handleCompany = (v) => {
    dispatch(ordersHandleFiltersInputs("company", v.company));
    dispatch(ordersHandleFiltersInputs("stations", v.company?.stations || []));
  }

  // Restaurar los filtros del formulario desde localStorage
  // cuando la redirección viene desde un refresh en OrderSettings
  useEffect(() => {
    if (location.state?.fromOrderSettings) {
      const searchParams = getPersistLocalStorage(ORDERS_SEARCH_PARAMS);
      if (searchParams) {
        dispatch(restoreOrderFilters({
          startDate: searchParams.startDate,
          endDate: searchParams.endDate,
          filter: searchParams.filter,
          company: searchParams.company,
          stations: searchParams.stationObjects,
        }));
      }
      hist.replace(location.pathname, {});
    }
  }, []);

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        width: "100%",
        padding: 4,
      }}
    >
      <Grid container spacing={1}>
        <Grid item xs={12} sm={2} style={style}>
          <TextField
            label="Desde"
            type="date"
            name="startDate"
            value={startDate}
            variant="outlined"
            fullWidth
            required={true}
            onChange={handleDateChange("startDate")}
            size="small"
            inputProps={{ ...dateRange }}
          />
        </Grid>

        <Grid item xs={12} sm={2} style={style}>
          <TextField
            label="Hasta"
            type="date"
            name="endDate"
            value={endDate}
            variant="outlined"
            fullWidth
            onChange={handleDateChange("endDate")}
            size="small"
            inputProps={{ ...dateRange }}
          />
        </Grid>
        <Grid item xs={12} sm={3} style={style}>
          <AutocompleteComponent
            label="Filtrar por"
            size="small"
            options={filterList || []}
            name="filter"
            value={filter || null}
            handleValues={handleFilter}
            fullWidth
          />
        </Grid>
        {filter?.value === ORDER_FILTER_OPTIONS.COMPANY ? 
          <Grid item xs={12} sm={3} style={style}>
            <AutocompleteComponent
              label="Empresa"
              size="small"
              options={companiesList || []}
              name="company"
              value={company || null}
              handleValues={handleCompany}
              fullWidth
            />
          </Grid> : 
          <Grid item xs={12} sm={11} style={style}>
            <Autocomplete
              id="order-stations-agent"
              options={filter?.value === ORDER_FILTER_OPTIONS.IS_AGENT ? agentList : stationsList}
              value={stations}
              getOptionLabel={(option) =>
                option.label ? option.label : option.name
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="stations"
                  label={filter?.value === ORDER_FILTER_OPTIONS.IS_AGENT ? "Agentes" : "Plantas"}
                  variant="outlined"
                  size="small"
                />
              )}
              fullWidth
              onChange={(_, v) => handleChange(v)}
              noOptionsText={
                filter?.value === ORDER_FILTER_OPTIONS.IS_AGENT
                  ? "No se encuentra agente"
                  : "No se encuentra la planta"
              }
              multiple
            />
          </Grid>
        }
        <Grid
          item
          xs={12}
          sm={1}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <RegularButton color="info" onClick={handleSubmit} fullWidth>
            buscar
          </RegularButton>
        </Grid>
      </Grid>
    </form>
  );
};
